import { Box } from '@mui/material'

import { GridCellParams } from '@mui/x-data-grid'
import { StatusChip } from '../../shared/StatusChip'

interface StatusRowCellProps extends GridCellParams {
  copy: any
}

const StatusRowCell = (params: StatusRowCellProps) => {
  return (
    <Box sx={{ p: 16, textAlign: 'center', width: '100%' }}>
      <StatusChip copy={params.copy} status={params.row.status} />
    </Box>
  )
}

export default StatusRowCell
